import React from "react";
import QuoteStepBase from '../../components/QuoteStepBase'
import { Alert } from 'react-bootstrap'
import { IQuoteStepState, IQuoteStepComponentProps } from "../../components/interfaces";
import { QuoteStep } from "./QuoteStepLayout";
import { connect } from "react-redux";
import { FULL_QUOTE_STEPS } from "../../AppConstants";
import { IBindResult } from "../../classes/ExternalQuote";
import { IAppState } from "../../state/interfaces";
import Utilities from "../../classes/Utilities";
import { IQuoteApiClient, IPaths } from "../../classes/Domain";
import QuoteActions from "../../state/appActions";


interface IState extends IQuoteStepState {
}

interface IProps extends IQuoteStepComponentProps {
    bindResult: IBindResult | null,
    quoteApiClient: IQuoteApiClient,
    PATHS: IPaths;
}

class Finish extends QuoteStepBase<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            updatingStore: false,
            errors: null
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    render() {
        return (
            <QuoteStep id="finish" className="policy-details">
                {
                    this.props.bindResult?.isSuccess 
                        ?
                        <div>
                            <div className="titleArea">
                                <h5>Thank you for purchasing your policy with SMCI Insurance!</h5>
                            </div>

                            <p className="info">Click on the links below to download your insurance documents.</p>

                            {
                                this.props.bindResult?.documents.map((document) => (
                                    <p key={Utilities.uniqueId()}><i className="fas fa-file-download"></i> <a href={document.downloadUrl} target="_blank">{document.name}</a></p>
                                ))
                            }

                            <h6>Download our app!</h6>

                            <p className="info">Manage your policy, documents, and payments anytime.</p>

                            <div>
                                <p className="info">
                                    <a href="https://play.google.com/store/apps/details?id=com.savemoney.auto" target="_blank">
                                        <span>
                                            <img
                                                src="https://commons.wikimedia.org/wiki/Special:Redirect/file/Google_Play_Store_badge_EN.svg"
                                                alt="Get it on Google Play"
                                                style={{ width: "auto", height: "45px" }} />
                                        </span>
                                    </a>
                                </p>
                            </div>

                            <div>
                                <p className="info">
                                    <a href="https://apps.apple.com/app/save-money-auto/id6472714201" target="_blank">
                                        <span>
                                            <img
                                                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                                                alt="Download on the App Store"
                                                style={{ width: "auto", height: "50px" }} />
                                        </span>
                                    </a>
                                </p>
                            </div>

                            <p className="info">Follow us here:</p>

                            <div>
                                <p className="info">
                                    <a href="https://www.facebook.com/share/1Bm1jCBuvj/?mibextid=wwXIfr" target="_blank">
                                        <span>
                                            <img
                                                src="https://commons.wikimedia.org/wiki/Special:Redirect/file/2023_Facebook_icon.svg"
                                                alt="Follow us on Facebook"
                                                style={{ width: "28px", height: "auto" }} />
                                        </span>
                                        <span> Save Money Car Insurance | Tulsa OK</span>
                                    </a>
                                </p>
                            </div>

                            <div>
                                <p className="info">
                                    <a href="https://www.instagram.com/savemoneycarinsurance?igsh=ZXowZXA0bXRuNGZv" target="_blank">
                                        <span>
                                            <img
                                                src="https://upload.wikimedia.org/wikipedia/commons/e/e7/Instagram_logo_2016.svg"
                                                alt="Follow on Instagram"
                                                style={{ width: "28px", height: "auto" }} />
                                        </span>
                                        <span> Save money Car Insurance (@savemoneycarinsurance) • Instagram profile</span>
                                    </a>
                                </p>
                            </div>
                        </div>
                        :
                        <div>
                            <Alert variant={"danger"}>
                                <p><strong className="text-uppercase">Sorry! Can not process your quote!</strong></p>
                                <p>Please review errors below</p>
                                <ul>
                                    {
                                        this.props.bindResult?.errors.map((error) => (
                                            <li key={Utilities.uniqueId()}>
                                                <p className="text-uppercase">
                                                    {error}
                                                </p>
                                            </li>
                                        ))
                                    }
                                </ul>
                                <p><a href={Utilities.getHomePageUrl()} className="font-weight-bold m-b-0"><i className="fas fa-chevron-left"></i> Home</a></p>
                            </Alert>
                        </div>
                }
                

            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        bindResult: state.externalQuote?.bindResult,
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(FULL_QUOTE_STEPS.FINISH))
    };
};

export default connect(mapProps, mapDispatch)(Finish);
